<dod-header />

<dod-banner />

<accredible-layout>
  <div layoutContent>
    <router-outlet />

    <dod-faq />
  </div>

  <div layoutSideContent>
    <dod-side-content />
  </div>
</accredible-layout>

<div class="dod-articles">
  <dod-side-content />
</div>

<dod-footer />

<accredible-cookies-banner />
